import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';

export class UtmLeadService {
  static async createUtmLead(data = {}) {
    try {
      const axiosInstance = getInstanceAxios();
      const responseServer = await axiosInstance.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/utm-leads/createUtm`,
        data,
      );

      return {
        error: false,
        message: responseServer.data,
        date: new Date(),
      };
    } catch (error) {
      return {
        error: true,
        message: error.response?.data?.message ?? error.message,
        date: new Date(),
        code: error.code,
        status: error.response?.status,
      };
    }
  }
}
